module.exports = __webpack_public_path__ + "fonts/Manrope-500-vietnamese10_c4999d3.woff2";